// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsertRowAboveOutlinedSvg from "@fishx/icons-svg/es/asn/InsertRowAboveOutlined";
import FishxIcon from '../components/FishxIcon';

var InsertRowAboveOutlined = function InsertRowAboveOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowAboveOutlinedSvg
  }));
};

InsertRowAboveOutlined.displayName = 'InsertRowAboveOutlined';
export default React.forwardRef(InsertRowAboveOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InsertRowAboveOutlined.js
// module id = 2971
// module chunks = 0